import "./assets/css/App.css";
import { Box } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import ComponentRouter from "./Router";

function App() {
  return (
    <Box>
      <HelmetProvider>
        <ComponentRouter />
      </HelmetProvider>
    </Box>
    // <Box sx={{ display: "flex" }}>
    //   <Box component="main" sx={{ flexGrow: 1 }}>
    //     <ComponentRouter />
    //   </Box>
    // </Box>
  );
}

export default App;
